import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/logo-light.svg'
import _imports_2 from '@/assets/img/elipse_menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-3df4db00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header row no-margin" }
const _hoisted_2 = { class: "nav-bar header-logo" }
const _hoisted_3 = {
  style: {"display":"flex","align-items":"center"},
  class: "float-right"
}
const _hoisted_4 = {
  key: 2,
  class: "float-right m-top-13 d-md-block d-sm-block"
}
const _hoisted_5 = {
  key: 0,
  class: "sign-in"
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"white"},
  class: "sign-in"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "elipse-menu-mb" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 4,
  class: "float-right m-top-13 d-sm-none d-md-block d-none d-sm-block"
}
const _hoisted_10 = {
  key: 0,
  class: "sign-up"
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"white"},
  class: "sign-up"
}
const _hoisted_12 = {
  key: 0,
  class: "log-out"
}
const _hoisted_13 = { href: "javascript:void(0)" }
const _hoisted_14 = {
  key: 1,
  style: {"color":"white"},
  class: "log-out"
}
const _hoisted_15 = {
  style: {"color":"white"},
  href: "javascript:void(0)"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_langpicker = _resolveComponent("langpicker")!
  const _component_v_runtime_template = _resolveComponent("v-runtime-template")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "float-left",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.home && _ctx.home(...args)))
      }, [
        (!_ctx.light_logo || null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: _normalizeClass(["logo", _ctx.showProspectForm ? 'logo-highlight' : '']),
              src: _imports_0
            }, null, 2))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: _normalizeClass(["logo", _ctx.showProspectForm ? 'logo-highlight' : '']),
              src: _imports_1
            }, null, 2))
      ]),
      _createElementVNode("div", _hoisted_3, [
        ((_ctx.csrfLoaded && (_ctx.pageType === '1' || _ctx.languagePicker)) || null)
          ? (_openBlock(), _createBlock(_component_langpicker, {
              key: 0,
              style: {"order":"2"},
              class: "d-sm-none mobile-hide d-md-block d-none float-right m-top-13",
              "is-header-logo": true,
              onLangChanged: _ctx.langChanged
            }, null, 8, ["onLangChanged"]))
          : _createCommentVNode("", true),
        ((_ctx.csrfLoaded && (_ctx.pageType === '1' || _ctx.languagePicker)) || null)
          ? (_openBlock(), _createBlock(_component_langpicker, {
              key: 1,
              "is-mobile": true,
              "is-header-logo": true,
              style: {"order":"2"},
              class: "d-sm-block d-md-none float-right m-top-13",
              onLangChanged: _ctx.langChanged
            }, null, 8, ["onLangChanged"]))
          : _createCommentVNode("", true),
        (_ctx.pageType === '1' || null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!_ctx.light_logo || null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-nav-signin-link-text-1")), 1),
                    _createElementVNode("a", {
                      id: "signin-link",
                      href: "javascript:void(0)",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickSignIn && _ctx.onClickSignIn(...args)))
                    }, _toDisplayString(_ctx.getUiText("app-prospect-nav-signin-link-1")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.getUiText("app-prospect-nav-signin-link-text-1")), 1),
                    _createElementVNode("a", {
                      id: "signin-link",
                      style: {"color":"white"},
                      href: "javascript:void(0)",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickSignIn && _ctx.onClickSignIn(...args)))
                    }, _toDisplayString(_ctx.getUiText("app-prospect-nav-signin-link-1")), 1)
                  ]))
            ]))
          : (_ctx.pageType === '2' || null)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "right-menu mb-menu-view",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.slideMenu && _ctx.slideMenu(...args)))
              }, _hoisted_8))
            : (_ctx.pageType === '3' || null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!_ctx.light_logo || null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_component_v_runtime_template, { template: _ctx.createAccountText }, null, 8, ["template"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_v_runtime_template, { template: _ctx.createAccountText }, null, 8, ["template"])
                      ]))
                ]))
              : (_ctx.pageType === '4' || null)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: "float-right m-top-13 d-sm-none d-md-block d-none d-sm-block",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickLogout && _ctx.onClickLogout(...args)))
                  }, [
                    (!_ctx.light_logo || null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.getUiText("app-user-nav-logout-link-1")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.getUiText("app-user-nav-logout-link-1")), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true)
      ])
    ])
  ]))
}